// @flow
import * as React from 'react';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';
import parse from 'date-fns/parse';
import { Container, Row, Col } from 'reactstrap';

// components
import { Icon } from 'components/atoms/Icon/';
import ContentFooter from 'components/pages/components/ContentFooter';

// Utils
import { formatTime } from 'utils/date';

import './CancellationPage.scss';

const ns = 'cancellation-page';

type Props = {
  appointmentDate: Object,
  intl: IntlShape
};

const CancellationPage = ({ intl, appointmentDate }: Props) => {
  const date = parse(appointmentDate.startTime);
  return (
    <Container className={`${ns} d-flex justify-content-center`}>
      <Row>
        <Col>
          <span className={`${ns}__subtitle d-flex justify-content-sm-center`}>
            {intl.formatMessage({ id: 'c8.cancel.page.sorry.to.see.you.go' })}
          </span>
          <br />
          <span
            className={`${ns}__subtitle--canceled d-flex justify-content-sm-center`}
          >
            {intl.formatMessage({
              id: 'c8.cancel.page.appointment.canceled.successfully'
            })}
          </span>
          <div
            className={`${ns}__cancellation-date d-flex align-items-center p-2`}
          >
            <Icon type="calendar" className={`${ns}__icon`} />
            <span className={`${ns}__label-date`}>
              {intl.formatDate(date, {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
              })}{' '}
              {formatTime(date, intl, false, false)}
            </span>
            <span className={`${ns}__label-canceled ml-auto`}>
              {intl.formatMessage({ id: 'c8.cancel.page.canceled' })}
            </span>
          </div>
        </Col>
        <ContentFooter />
      </Row>
    </Container>
  );
};

export default injectIntl(CancellationPage);



// WEBPACK FOOTER //
// ./src/components/pages/Appointment/CancellationPage/CancellationPage.js